import { useContext } from "react";
import { useMatches } from "react-router";

import { useBackNavigationContext } from "@/components/contexts/backNavigationContext";
import { PageTitleContext } from "@/components/contexts/pageTitleContext";
import Subheader from "@/screens/subheader/Subheader.js";
import { useBackNavigation } from "@hooks/backNavigation/useBackNavigation";

// The deepest matched route's `handle.title`, for pages that don't publish one
// via useSetPageTitle.
export const routeTitle = (matches) =>
  [...matches].reverse().find((match) => match.handle?.title)?.handle.title ??
  "";

/** App-only title + back bar for pages that don't render their own back control. */
const AppBackBar = () => {
  const { showBack } = useBackNavigation();
  const ownerCount = useBackNavigationContext()?.ownerCount ?? 0;
  const pageTitle = useContext(PageTitleContext)?.pageTitle;
  const matches = useMatches();

  if (!showBack || ownerCount > 0) {
    return null;
  }

  const title = pageTitle || routeTitle(matches);
  return (
    <Subheader
      title={title}
      tabs={null}
      currentTab={null}
      ownsBack={false}
      analytics={{ section: title || undefined, pageTitle: title }}
    />
  );
};

export default AppBackBar;
